import Modal from '@porterin/component-library/src/base-components/modal/Modal';
import React from 'react';

import FareEstimateRequirementCmp from './FareEstimateRequirementCmp';

type identifiers = {
  id: string;
};

interface FareEstimateRequirementModalCmpProps {
  isOpen: boolean;
  requirementHandler: (value: boolean) => void;
  selectedRequirement: 'personal' | 'business' | null;
  identifiers: identifiers;
}

const FareEstimateRequirementModalCmp: React.FC<
  FareEstimateRequirementModalCmpProps
> = ({ isOpen, requirementHandler, selectedRequirement, identifiers }) => {
  return (
    <Modal
      identifiers={{
        id: identifiers.id,
        className: 'w-full bottom-0% left-0%',
      }}
      modalOptions={{
        isOpen: isOpen,
        showOverlay: true,
        position: 'bottom-center',
      }}
      interactions={{ onClose: () => requirementHandler(false) }}
    >
      <FareEstimateRequirementCmp
        identifiers={{ id: 'requirement-selection' }}
        requirementHandler={requirementHandler}
        selectedRequirement={selectedRequirement}
      />
    </Modal>
  );
};

export default FareEstimateRequirementModalCmp;
